<template>
	<b-container fluid class="d-flex flex-column w-100 h-100 px-2">
		<b-row v-for="section in form.Sections" :key="section.Name" class="p-3 m-0">
			<b-col class="m-0">
				<b-card no-body class="p-3">
					<b-form-group
						:label="section.Label"
						label-cols="12"
						label-cols-lg="12"
						label-class="font-weight-bold text-dark pt-0 pb-2"
						label-align-sm="left"
						label-size="lg"
						class="m-0" />
					<b-button-toolbar v-if="ConsultMode !== objectDisplayingModeEnum.Read" key-nav :aria-label="$t('ToolbarButtons')">
						<b-button-group class="pt-1 pb-1">
							<b-button v-b-tooltip.hover :title="$t('AddContact')" @click="displayModal(undefined)" variant="outline-secondary" class="btn-circle-small"><b-icon icon="person-plus-fill" /></b-button>
						</b-button-group>
					</b-button-toolbar>
					<b-card no-body class="w-100">
						<b-card-header header-tag="header" header-bg-variant="secondary" class="text-center text-white font-weight-bold pt-0 pb-0" role="tab">
							{{ section.Label }}
						</b-card-header>
						
						<!-- Construit la liste de champs -->
						<!-- <Fields v-bind:Fields="section.Fields.filter(x => x.Type !==  fieldTypeEnum.Table)" v-bind:ConsultMode="ConsultMode" /> -->

						<!-- Tableau des contacts -->
						<b-table v-for="table in section.Fields.filter(x => x.Type === fieldTypeEnum.Table)" :key="table['Name']" :fields="convertHeaders(table['Headers'])" :items="table.Value"
							striped bordered hover small class="m-0" tbody-tr-class="p-0">
							<template #head()="data">
								<div class="text-center">{{ data.label }}</div>
							</template>
							<template #cell(Type)="data">
								<b-form-select 
									:options="listItems"
									:disabled="ConsultMode === objectDisplayingModeEnum.Read"
									value-field="Id"
									text-field="Label"
									size="sm"
									plain
									v-model="data.item.Type"
									:required="true" />
									<!-- 
										:id="field.Name"
										:readonly="field.ReadOnly"
										:required="field.Required"
										:state="field.State" -->
							</template>

							<!-- Section contenant les boutons de mise-à-jour et suppression d'une ligne de Contact -->
							<template #cell(remove)="row">
								<div class="text-center">
									<b-button v-b-tooltip.hover :title="$t('RemoveFromList')" size="sm" pill variant="outline-danger" class="text-center p-0 m-0 border-0" @click="remove(row.item.Id)"><font-awesome-icon icon="x" /></b-button>
								</div>
							</template>
							<template #cell(edit)="row">
								<div class="text-center">
									<b-button v-b-tooltip.hover :title="$t('ShowDetails')" size="sm" pill variant="outline-secondary" class="text-center p-0 m-0 border-0" @click="displayModal(row.item)"><b-icon icon="search"/></b-button>
								</div>
							</template>
						</b-table>
					</b-card>
				</b-card>
			</b-col>
		</b-row>
	  <b-modal id="contactModal" v-model="displayContactModal" centered>
			<template #modal-header="{ }">
				<h6><b-icon icon="person-fill" class="mr-2" />{{$t('Contact')}}</h6> <!-- Contact : Contact -->
			</template>
 			<!-- SelectContact : -- Sélectionnez un contact -- -->
			<multiselect v-if="!modifyMode"
				v-model="editedContact"
				:options="fullContacts"
				:close-on-select="true"
				:allow-empty="false"
				:show-labels="false"
				:disabled="ConsultMode === objectDisplayingModeEnum.Read"
				:placeholder="$t('SelectContact')" 
				label="FullName"
				track-by="Id"
				class="pb-1 mb-0" >
			</multiselect>

			<b-card no-body class="pl-2 pr-2 pb-0 pt-2">
				<!-- Name : Nom -->
				<b-form-group
					:label="$t('Name')"
					label-cols-sm="4"
					label-for="fullName"
					label-class="pt-0 pb-0 pr-0"
					label-align-sm="left">
					<b-input-group id="fullName">
						<b-form-input
							type="text"
							:disabled="ConsultMode === objectDisplayingModeEnum.Read"
							readonly
							v-model="editedContact.FullName" />
					</b-input-group>
				</b-form-group>
				<!-- Organization : Organisme -->
				<b-form-group
					:label="$t('Organization')"
					label-cols-sm="4"
					label-for="company"
					label-class="pt-0 pb-0 pr-0"
					label-align-sm="left">
					<b-input-group id="company">
						<b-form-input
							type="text"
							:disabled="ConsultMode === objectDisplayingModeEnum.Read"
							readonly
							v-model="editedContact.Company" />
					</b-input-group>
				</b-form-group>
				 <!-- Function : Fonction -->
				<b-form-group
					:label="$t('Function')"
					label-cols-sm="4"
					label-for="functionInCompany"
					label-class="pt-0 pb-0 pr-0"
					label-align-sm="left">
					<b-input-group id="functionInCompany">
						<b-form-input
							type="text"
							:disabled="ConsultMode === objectDisplayingModeEnum.Read"
							readonly
							v-model="editedContact.FunctionInCompany" />
					</b-input-group>
				</b-form-group>
				<!-- Phone : Téléphone -->
				<b-form-group
					:label="$t('Phone')"
					label-cols-sm="4"
					label-for="telNumber"
					label-class="pt-0 pb-0 pr-0"
					label-align-sm="left">
					<b-input-group id="telNumber">
						<b-form-input
							type="text"
							:disabled="ConsultMode === objectDisplayingModeEnum.Read"
							readonly
							v-model="editedContact.TelNumber" />
					</b-input-group>
				</b-form-group>
				<!-- Mobile : Portable -->
				<b-form-group
					:label="$t('Mobile')"
					label-cols-sm="4"
					label-for="portNumber"
					label-class="pt-0 pb-0 pr-0"
					label-align-sm="left">
					<b-input-group id="portNumber">
						<b-form-input
							type="text"
							:disabled="ConsultMode === objectDisplayingModeEnum.Read"
							readonly
							v-model="editedContact.PortNumber" />
					</b-input-group>
				</b-form-group>
				 <!-- Email : Courriel -->
				<b-form-group
					:label="$t('Email')"
					label-cols-sm="4"
					label-for="email"
					label-class="pt-0 pb-0 pr-0"
					label-align-sm="left">
					<b-input-group id="email">
						<b-form-input
							type="text"
							:disabled="ConsultMode === objectDisplayingModeEnum.Read"
							readonly
							v-model="editedContact.Email" />
					</b-input-group>
				</b-form-group>
				<!-- Address : Adresse -->
				<b-form-group
					:label="$t('Address')"
					label-cols-sm="4"
					label-for="address"
					label-class="pt-0 pb-0 pr-0"
					label-align-sm="left">
					<b-input-group id="address">
						<b-form-input
							type="text"
							:disabled="ConsultMode === objectDisplayingModeEnum.Read"
							readonly
							v-model="editedContact.Address" />
					</b-input-group>
				</b-form-group>
				<!-- PostalCode : Code postal -->
				<b-form-group
					:label="$t('PostalCode')"
					label-cols-sm="4"
					label-for="postalCode"
					label-class="pt-0 pb-0 pr-0"
					label-align-sm="left">
					<b-input-group id="postalCode">
						<b-form-input
							type="text"
							:disabled="ConsultMode === objectDisplayingModeEnum.Read"
							readonly
							v-model="editedContact.PostalCode" />
					</b-input-group>
				</b-form-group>
				 <!-- City : Ville -->
				<b-form-group
					:label="$t('City')"
					label-cols-sm="4"
					label-for="town"
					label-class="pt-0 pb-0 pr-0"
					label-align-sm="left">
					<b-input-group id="town">
						<b-form-input
							type="text"
							:disabled="ConsultMode === objectDisplayingModeEnum.Read"
							readonly
							v-model="editedContact.Town" />
					</b-input-group>
				</b-form-group>
				<!-- Country : Pays -->
				<b-form-group
					:label="$t('Country')"
					label-cols-sm="4"
					label-for="country"
					label-class="pt-0 pb-0 pr-0"
					label-align-sm="left">
					<b-input-group id="country">
						<b-form-input
							type="text"
							:disabled="ConsultMode === objectDisplayingModeEnum.Read"
							readonly
							v-model="editedContact.Country" />
					</b-input-group>
				</b-form-group>
			</b-card>

			<template #modal-footer="{ cancel }">
				<!-- Close : Fermer -->
				<b-button @click="cancel()" variant="outline-secondary" pill>{{$t('Close')}}</b-button>
				<!-- Select : Sélectionner -->
				<b-button v-if="!modifyMode" @click="add()" variant="secondary" pill>{{$t('Select')}}</b-button>
			</template>
		</b-modal>
		
		<!-- Zone d'affichage des erreurs de validation de formulaire -->
		<b-toast id="toastContact" variant="danger" solid toaster="b-toaster-top-center">
			<template #toast-title>
					<!-- Error : Erreur -->
					<b-icon icon="exclamation-circle" class="h4 mt-2 mr-2"/><b>{{$t('Error')}}</b>
			</template>
			{{ errorMessage }}
		</b-toast>
	</b-container>
</template>

<script lang="ts">
	import { Component, Vue } from "vue-property-decorator";
	import Multiselect from 'vue-multiselect';
	import Fields from "@/components/commons/Fields.vue";
	import FieldTypeEnum from "@/enums/fields/FieldTypeEnum";
	import TableHeader from "@/types/fields/TableHeader";
	import ListItem from "@/types/fields/ListItem";
	import Contact from "@/types/Contact";
	import axios from "axios";
	import { API_URL } from "@/App.settings";
	import Dictionary from "@/types/Dictionary";
	import ObjectDisplayingModeEnum from "@/enums/ObjectDisplayingModeEnum";
	import TableField from "@/types/fields/TableField";
	import { BaseObjectForm } from "./BaseObjectForm";
	import locales from "./locales/Contact.json";

	/** Composant de gestion des contacts dans la fiche objet */
	@Component({
		components: {
			Multiselect,
			Fields
		},
		i18n: { messages: locales }
	})
	export default class Contacts extends BaseObjectForm {
		/** Pour pouvoir utiliser l'enum FieldTypeEnum dans la section template */
		private fieldTypeEnum = FieldTypeEnum;
		private objectDisplayingModeEnum = ObjectDisplayingModeEnum;

		/** Nom de la liste à interroger côté server pour obtenir les types de contacts  */
		private contactTypeListName: string = "ContactType";

		/** Items de SelectList */
        private listItems: ListItem[] = [];

		//#region Fenêtre modale de saisie d'un évènement
		private displayContactModal: boolean = false;

		private editedContact: Contact = {
				Id: "",
				FullName: "",
				Company: "",
				TelNumber: "",
				PortNumber: "",
				Type: 0,
				Email: "",
				Address: "",
				PostalCode: "",
				Town: "",
				Country: "",
				FunctionInCompany: ""
			};
		
		private modifyMode: boolean = false;

		private errorMessage: string = "";

		/** Liste complète des contacts utilisée pour sélection de contact dans la fenêtre modale */
		private fullContacts: Contact[] = [];
		//#endregion Fenêtre modale de saisie d'un évènement

		/** 
		 * Convertie un TableHeader en header compatible avec le Bootstrap Vue.js b-Table utilisé dans ce composant
		 * @param headers: Liste de TableHeader à convertir
		 *  */
		private convertHeaders(headers: TableHeader[]) {
			let tab = headers.map(o => {
				return { key: o.Name, label: o.Label, sortable: true, thStyle: {} };
			});

			if (this.ConsultMode != ObjectDisplayingModeEnum.Read) {	// Si on est en mode édition
				// Ajout d'une colonne Remove pour placer le bouton Remove
				tab.unshift({ key: "remove", label: "", sortable: false, thStyle: { width: "10px" } });

				// Ajout d'une colonne Edit pour placer le bouton Edit
				tab.push({ key: "edit", label: "", sortable: false, thStyle: { width: "10px" } });
			}
			// let objId = { key: "Id", label: "Id", sortable: false, thStyle: {} };
			// tab.push(objId);

			return tab;
		}

		/** Affichage de la fenêtre modal d'édition d'un évènement */
		private displayModal(item: Contact) {
			if (item) {
				this.modifyMode = true;
				this.editedContact = item;
			}
			else {
				this.editedContact = {
					Id: "",
					FullName: "",
					Company: "",
					TelNumber: "",
					PortNumber: "",
					Type: 0,
					Email: "",
					Address: "",
					PostalCode: "",
					Town: "",
					Country: "",
					FunctionInCompany: ""
				};
				this.modifyMode = false;

				/** @todo: récupérer ici la liste complètes des contacts pour naviguer */
			}
			this.displayContactModal = true;
		}

		private add() {
			console.debug("Contacts - add()");

			if (this.editedContact.Id == "") {
				this.errorMessage = this.$t('MustSelectContact').toString(); // Vous devez sélectionner un contact !
				this.$bvToast.show('toastContact')

				return;
			}

			// Si le contact n'est pas déjà dans la liste alors on l'ajoute
			if ((this.form.Sections[0].Fields[0] as TableField).Value.findIndex(x => x.Id === this.editedContact.Id ) > -1 ) {
				this.errorMessage = this.$t('ContactAlreadyAdded').toString(); // Le contact sélectionné a déjà été ajouté !
				this.$bvToast.show('toastContact')
			}
			else {
				(this.form.Sections[0].Fields[0] as TableField).Value.push(this.editedContact);
				this.displayContactModal = false;
			}
		}

		private remove(id: string) {
			this.$bvModal.msgBoxConfirm(this.$t('ConfirmRemoveContact').toString(), { // Voulez-vous vraiment retirer ce contact ? Cette action sera effective après la sauvegarde.
				title: this.$t('Contact').toString(), okVariant: 'danger', okTitle: this.$t('Yes').toString(), cancelTitle: this.$t('No').toString(), hideHeaderClose: false, centered: true
				}).then(value => {
					if (value) {
						let index: number = (this.form.Sections[0].Fields[0] as TableField).Value.findIndex(x => x.Id == id);
						(this.form.Sections[0].Fields[0] as TableField).Value.splice(index, 1);
					}
				});
		}

		async mounted() {
			// Chargement de la liste complète des contacts en arrière-plan 
			/** @todo: à mettre plutôt à l'ouverture de la modale ? et à ne charger qu'une seule fois... ? Sauf que si on en ajoute alors on ne les verra pas... */
			const args: Dictionary<any> = {};
			args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";

			await axios.post(API_URL + "object/LoadContacts", args).then((response) => {
					if (response.data)
						this.fullContacts = response.data;
				})
				.catch(err => {
					console.error(err);
					this.$bvToast.toast(this.$t('ErrorOccurred').toString(), { // Une erreur est survenue. Veuillez contacter votre administrateur.
						title: this.$t('ConnectionError').toString(),// Erreur de connexion
						autoHideDelay: 10000,
						variant: "danger",
						solid: true,
						appendToast: true,
						toaster: "b-toaster-top-center"
					});
				})

			// Chargement de la liste des types de contacts (si pas déjà chargée)
			await this.$store.dispatch("LoadListItems", [{ listName: this.contactTypeListName }]).then(response => {
				this.listItems = this.$store.getters["GetListItems"](this.contactTypeListName);
				console.debug("Contacts - LoadListItems - x.ListName : ContactType - Chargement de la liste des ListItems terminée");
			})
			.catch(err => {
				console.error(err);
				this.$bvToast.toast(this.$t('ErrorOccurred').toString(), { // Une erreur est survenue. Veuillez contacter votre administrateur.
					title: this.$t('ConnectionError').toString(),// Erreur de connexion
					autoHideDelay: 10000,
					variant: "danger",
					solid: true,
					appendToast: true,
					toaster: "b-toaster-top-center"
				});
			});
		}
	}
</script>

<style scoped>

</style>